import { BrowserUtils, StringUtils, QuestionUtils, StorageUtils, QueryUtils } from '../utils/siteUtils'
import { CertificatePageNumber, VehiclePageNumber, LandingPageNumber, SummaryPageNumber, HistoryPageNumber, ImageCapturePageNumber, AftermarketPageNumber, ExteriorPageNumber, ContactPageNumber } from '../constants'

class LandingContext {
  constructor(dynamicContext, pageContext, location, globalState, updateGlobalState, yearParam, yearQuery, makeQuery, modelQuery, experienceState, qxData, offer, offerError, offerIsFetching, isInitialCertificateViewing, autoCheckData) {
    this.locationState = location.state || {}
    this.offer = offer
    this.offerError = offerError && offerError[0]
    this.offerIsFetching = offerIsFetching
    this.isInitialCertificateViewing = isInitialCertificateViewing
    this.experienceState = experienceState
    this.isCatchall = !pageContext.experience
    this.yearParam = yearParam || yearQuery
    this.globalState = globalState
    this.updateGlobalState = updateGlobalState
    this.showModal = globalState.showModal
    Object.keys(dynamicContext).forEach(key => (this[key] = dynamicContext[key] || pageContext[key]))
    this.isLinksPage = process.env.BUILD_STAGE === 'build-html' && pageContext.isLinksPage
    this.generatedLandingType = BrowserUtils.isSSG && pageContext.generatedLandingType
    this.sessionLandingType = BrowserUtils.isClientSide && StorageUtils.isAllowed() && sessionStorage.getItem('GeneratedLandingType')
    this.qxData = qxData
    this.autoCheckData = autoCheckData
    this.makeQuery = makeQuery
    this.modelQuery = modelQuery
    this.amQ = 'amQ'
    const initUrlState = QueryUtils.getInitUrlState(location)
    if (location.initQueryParams.options) initUrlState.o = location.initQueryParams.options.split('|').map(option => `${option}T`) //split returns array with empty string when null
    this.urlState = { ...initUrlState, ...StringUtils.getUrlState(location) }
    BrowserUtils.setHistoryUrlState(this.urlState)
    const isOutageError = globalState && globalState.isOutageError
    const prospectIdParam = this.urlState.pa && this.urlState.pa[0] && this.urlState.pa[0].indexOf('prospect') === 0 && this.urlState.pa[1]
    if (this.urlState.p === undefined) {
      if (this.offer) {
        if (this.locationState.offer || (!location.initQueryParams.review && location.initPathParams[2] !== 'review' && location.initPathParams[0] !== 'reviewoffer')) this.urlState.p = CertificatePageNumber
        else {
          if (!this.urlState.vin) this.urlState.vin = this.offer.prospect.vehicle.vin //not good, update wherever it is being used - 5TDZK3DC7CS205050
          this.urlState.p = this.offer.quickQuote ? (this.urlState.vin ? VehiclePageNumber : LandingPageNumber) : SummaryPageNumber
          if (this.urlState.p === SummaryPageNumber) this.urlState.edit = 1
        }
      } else if (isOutageError || prospectIdParam) {
        this.urlState.p = CertificatePageNumber
      } else this.urlState.p = LandingPageNumber
    }
    if (this.offer && !this.offer.quickQuote && !this.offer.isExpired) this.urlState.lp = CertificatePageNumber

    this.mileage = typeof this.urlState.m !== 'undefined' ? this.urlState.m : this.offer && this.offer.prospect.mileage

    if (this.experienceState?.isAdmin) {
      var answerSourcesQuestion = this.prospectDocuments?.wipReadback?.answers?.filter(item => item.qRef === 'qx/AnswerSources')
      var accidentAnswer = this.offer?.prospect?.history?.find(e => e.questionId === 'qp/124')
      var answerSourceInputArray = this.qxData?.find(data => data.questionId === 'qx/AnswerSourcesInput')
      var dealerModifiedQuestion = answerSourceInputArray?.value?.find(item => item.questionCode === 'DealerModifiedAccidentQuestion')
      if (accidentAnswer != null && accidentAnswer?.value?.toLowerCase() != 'no') {
        if (!answerSourcesQuestion?.find(x => x.QuestionCode == 'qp/124') && !this.autoCheckData?.hasAccidents) {
          dealerModifiedQuestion.value = true
        } else {
          dealerModifiedQuestion.value = false
        }
      }
    }

    this.nextClick = nextStep => {
      const autoCheckAndVehicleActivity = this.autoCheckData && this.vinResults && !this.vinResults.vehicleActivityApplicationDown
      let ymmt = this.urlState && this.urlState.displayYMM && !this.urlState.vin
      //store history for cancel
      this.updateGlobalState({ historyState: { year: this.year, make: this.make, model: this.model, urlState: this.urlState } })
      if (!this.experienceState.isAdmin && !ymmt) {
        // if autoCheck exists and VehicleActivity isn't down and about to go to VehicleHistory, go to ImageCapture
        if (autoCheckAndVehicleActivity && ((nextStep && nextStep === HistoryPageNumber) || (nextStep === undefined && this.urlState && this.urlState.p && this.urlState.p === AftermarketPageNumber))) {
          nextStep = ImageCapturePageNumber
        }
      }

      //if dealer is sell2kbb pilotv2, we should skip the photo upload screen
      if ((this.experienceState.dealerIsDirectToKBBv2 || this.experienceState.skipPhotoUpload) && nextStep && nextStep === ImageCapturePageNumber) {
        // Default Condition Page values for analytics. This normally happens in ImageCapture.js, but since we're skipping it...
        this.updateGlobalState({ np: ExteriorPageNumber, cp: ExteriorPageNumber })
        nextStep = ExteriorPageNumber
      }

      if (this.urlState.p === ImageCapturePageNumber) {
        nextStep = ExteriorPageNumber
      }

      return nextStep ? this.goToStep(nextStep) : this.progressStep(1)
    }
    this.backClick = backStep => {
      const autoCheckAndVehicleActivity = this.autoCheckData && this.vinResults && !this.vinResults.vehicleActivityApplicationDown
      let ymmt = this.urlState && this.urlState.displayYMM && !this.urlState.vin
      let skipPhotoUpload = (this.experienceState.dealerIsDirectToKBBv2 || this.experienceState.skipPhotoUpload) && this.urlState.p === ExteriorPageNumber
      // if autoCheck exists and VehicleActivity isn't down and on ImageCapture page
      //    if VehicleMod exists, go back 2 pages to skip VehicleHistory
      //    if VehicleMod doesn't exist, go back 3 pages to skip VehicleHistory and VehicleMod
      //    else go back 1 page
      if (typeof backStep === 'number') {
        this.goToStep(backStep)
      } else if (!this.experienceState.isAdmin && !ymmt) {
        if (autoCheckAndVehicleActivity && (this.urlState.p === ImageCapturePageNumber || skipPhotoUpload)) {
          if (this.getHasVehicleModifications()) {
            this.progressStep(skipPhotoUpload ? -3 : -2)
          } else {
            this.progressStep(-4)
          }
        } else {
          this.progressStep(skipPhotoUpload ? -2 : -1)
        }
      } else {
        this.progressStep(skipPhotoUpload ? -2 : -1)
      }
    }
    this.addImpressions = () => false //wait to load, it will be set once loaded
    this.loadingInfo = {}
  }

  setShowModal = showModal => {
    BrowserUtils.postMessage(JSON.stringify({ action: 'getFrameDetails' }), '*')
    this.updateGlobalState({ showModal, showExamples: false })
  }

  setLoadingInfo = (info, value) => (value ? (this.loadingInfo[info] = value) : delete this.loadingInfo[info])

  resetOptionSelections = () => BrowserUtils.navigateWithUrlState({ year: this.year, make: this.make, model: this.model, urlState: { ...this.urlState, o: [] } })

  navigateWithState = (updateState, state, initPath) => BrowserUtils.navigateWithUrlState({ year: this.year, make: this.make, model: this.model, urlState: this.urlState, updateState }, state, initPath)
  navigatePageWithState = (updateState, state = { scroll: 1 }, initPath) => this.navigateWithState(updateState, state, initPath)

  getUrlStateLink = (nohash, endhash) => BrowserUtils.getUrlStateLink({ year: this.year, make: this.make, model: this.model, urlState: this.urlState }, nohash, false, endhash)

  navigateVinClear = () => this.urlState.vin && this.navigateWithState({ vin: undefined })

  progressStep = step => {
    const fireAnalytics = step < 0 ? 'back' : 'continue'
    const lp = (this.urlState.p || 0) + step > (this.urlState.lp || 0) ? (this.urlState.p || 0) + step : this.urlState.lp
    this.updateGlobalState({ lp, fireAnalytics })
    this.navigateWithState({ p: (this.urlState.p || 0) + step, lp }, { scroll: 1 })
  }
  goToStep = step => {
    let fireAnalytics
    if (this.urlState.noDamageModal) {
      // Removed feature flag check since offer creation component is now always enabled
      this.urlState['noDamageModal'] = false
    } else {
      if (step === ContactPageNumber) {
        fireAnalytics = 'continue_to_contact'
      } else {
        fireAnalytics = step < this.urlState.p ? 'back' : 'continue'
      }
    }
    const lp = step > (this.urlState.lp || 0) ? step : this.urlState.lp
    this.updateGlobalState({ fireAnalytics })
    this.navigateWithState({ p: step, lp }, { scroll: 1 })
  }

  navigateToOffer = offer => BrowserUtils.navigateToOffer(offer)

  navigateToNewOfferWithVin = () => {
    const prospect = (this.offer && this.offer.prospect) || { contactInfo: {} }
    const { dealerRepId, isConsumerOffer, sendEmail, showCustOption } = prospect
    const { firstName, lastName, email, phone } = prospect.contactInfo
    const isQuickQuote = this.offer && this.offer.quickQuote
    const mutatedConsumerInfo = isQuickQuote ? {} : { firstName, lastName, email, phone }
    const mutatedDealerInfo = isQuickQuote ? {} : { dealerRepId, isConsumerOffer, sendEmail, showCustOption }
    this.experienceState.mutateExperienceForNewOffer(mutatedDealerInfo, mutatedConsumerInfo)

    this.navigateWithState({ p: LandingPageNumber, lp: LandingPageNumber, edit: undefined })
    // navigating with clearing here was very bad, it clears vin selection reflections on urlState
  }

  compressUrlStateName = name => StringUtils.toUrlDisplayName(name)

  saveQuestionResponseInteger = (questionId, value) => {
    this.navigateWithState({ [questionId]: { v: value !== '' ? +value : undefined } })
  }

  getQuestionResponseInteger = questionId => {
    let urlResponse = this.urlState[questionId] && this.urlState[questionId].v
    let offerResponse = undefined
    if (!urlResponse) {
      if (this.offer && !this.offer.quickQuote) {
        const question = this.getQuestionFromOffer(questionId)
        const choice = QuestionUtils.mapOfferToQuestionAnswer(questionId, question)
        if (choice || choice === 0) offerResponse = choice
      }
    }
    return urlResponse || offerResponse
  }

  saveQuestionResponse = (questionId, isSelected = true) => {
    this.updateDealerActivities(questionId, isSelected)
    if (this.getQuestionResponse(questionId).v === isSelected) {
      this.navigateWithState({ [questionId]: { ...this.urlState[questionId], v: undefined } })
      return
    }
    this.navigateWithState({ [questionId]: { ...this.urlState[questionId], v: isSelected } })
  }

  updateDealerActivities = (questionId, isSelected) => {
    if (this.experienceState.isAdmin && questionId === 'qp/124') {
      // User is a dealer and question is accident question
      const answerSourcesQuestion = this.prospectDocuments?.wipReadback?.answers?.filter(item => item.qRef === 'qx/AnswerSources')
      let answerSourcesArray = null
      const verifiedHistoryQuestionSource = this.qxData.find(data => data.questionId === 'qx/AreQuestionsVerified')
      if (answerSourcesQuestion?.length > 0 && answerSourcesQuestion[0].value) {
        answerSourcesArray = JSON.parse(answerSourcesQuestion[0].value)
      }
      const answerSourceInputArray = this.qxData.find(data => data.questionId === 'qx/AnswerSourcesInput')
      if (verifiedHistoryQuestionSource?.value === 1) {
        //Question was answered by autocheck and the answer was no for accident question
        let accidentAnswer = this.offer?.prospect?.history?.find(e => e.questionId === 'qp/124')
        const dealerModifiedQuestion = answerSourceInputArray.value.find(item => item.questionCode === 'DealerModifiedAccidentQuestion')
        if ((accidentAnswer?.value?.toLowerCase() === 'no' && dealerModifiedQuestion) || !this.autoCheckData?.hasAccidents) {
          dealerModifiedQuestion.value = isSelected !== 1
        }
      }
    }
  }

  saveMultipleQuestionResponse = (questionIdArray, answerIdArray) => {
    const updateState = questionIdArray.reduce((acc, curr, index) => {
      var ans = answerIdArray[index]
      var answered = this.getQuestionResponse(curr).v === ans
      acc[curr] = { ...this.urlState[curr], v: answered ? undefined : ans }
      return acc
    }, {})
    this.navigateWithState(updateState)
  }

  getQuestionResponse = questionId => {
    let urlResponse = this.urlState[questionId]
    let offerResponse = undefined
    if (!urlResponse) {
      if (this.offer && !this.offer.quickQuote) {
        const question = this.getQuestionFromOffer(questionId)
        const choice = QuestionUtils.mapOfferToQuestionAnswer(questionId, question)
        if (choice || choice === 0) offerResponse = { v: choice }
      }
    }
    return urlResponse || offerResponse || {}
  }

  getHasVehicleModifications = () => {
    let questionResponse = this.getQuestionResponse(this.amQ)
    let hasModification = undefined

    if (this.offer && !this.offer.quickQuote && !this.urlState.amQInit) {
      const vehicleInfo = this.offer.prospect
      const hasVMInfo = vehicleInfo && vehicleInfo.conditions && vehicleInfo.conditions.filter(item => item.section === 'Aftermarket').length > 0
      hasModification = hasVMInfo ? true : false
      this.urlState.amQInit = { v: +!hasModification }
      this.urlState.amQ = { v: +!hasModification }
      return hasModification
    }

    if (questionResponse.v === undefined) {
      return hasModification
    }

    hasModification = questionResponse.v ? false : true

    if (this.offer) {
      this.urlState.amQ = { v: +!hasModification }
    }

    return hasModification
  }

  getSelectedVehicleModifications = () => {
    const uniqueSections = arr => Array.from(new Set(arr.map(item => item.subsection)))
    const canBeResubmitted = this.offer && this.offer.canBeResubmitted
    const isExpired = this.offer && this.offer.isExpired
    const prospect = this.offer && this.offer.prospect
    const conditionQuestions = this.getConditionQuestions(prospect, canBeResubmitted, isExpired)
    const sections = []
    conditionQuestions &&
      uniqueSections(conditionQuestions).map(subsection => {
        if (this.anyAnswered(conditionQuestions.filter(i => i.subsection === subsection))) {
          const arr = []
          let questions = conditionQuestions.filter(item => item.subsection === subsection)
          questions.map(q => {
            this.isQuestionAnswered(q) && arr.push(q)
            return arr
          })
          sections.push({ subsection: subsection, questions: arr })
        }
        return sections
      })
    return sections
  }

  removeVehicleModifications = () => {
    const canBeResubmitted = this.offer && this.offer.canBeResubmitted
    const isExpired = this.offer && this.offer.isExpired
    const prospect = this.offer && this.offer.prospect
    const conditionQuestions = this.getConditionQuestions(prospect, canBeResubmitted, isExpired)
    const filtered = conditionQuestions.filter(q => this.isQuestionAnswered(q))
    const keepFilter = key => !filtered.some(q => key.includes(q.questionId))
    this.urlState = Object.keys(this.urlState).reduce((acc, cur) => ({ ...acc, ...(keepFilter(cur) ? { [cur]: this.urlState[cur] } : {}) }), {})
    if (this.offer && !this.offer.quickQuote) {
      filtered.map(q => {
        if (q.questionType === 'MultiSelect') {
          q.selectChoices.map(i => {
            this.urlState[i.qRef] = {}
          })
        } else this.urlState[q.questionId] = {}
      })
    }
    this.navigateWithState(this.urlState)
  }

  getConditionQuestions = (prospect, canBeResubmitted, isExpired) => {
    let conditionQuestions = undefined

    if (this.prospectDocuments) {
      conditionQuestions = this.prospectDocuments.documents && this.prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qc').items.filter(item => item.section === 'Aftermarket')
    }

    if (canBeResubmitted && isExpired) {
      conditionQuestions = prospect && prospect.conditions && prospect.conditions.filter(item => item.section === 'Aftermarket')
    }

    return conditionQuestions
  }

  anyAnswered = questions => questions.some(question => this.isQuestionAnswered(question))

  isQuestionAnswered = question => {
    if (question.questionType === 'MultiSelect') return question.selectChoices.some(choice => QuestionUtils.isQuestionAnswered(this.getQuestionResponse(choice.qRef).v))
    else if (question.questionType === 'ToggleSelect') return this.getQuestionResponse(question.questionId).v === 0 ? true : false
    else return QuestionUtils.isQuestionAnswered(this.getQuestionResponse(question.questionId).v)
  }

  getQuestionAnswerValues = question =>
    (question.questionType === 'MultiSelect'
      ? question.selectChoices.map(choice => QuestionUtils.isQuestionAnswered(this.getQuestionResponse(choice.qRef).v) && choice.value) //
      : ['1'].map(a => QuestionUtils.isQuestionAnswered(this.getQuestionResponse(question.questionId).v) && question.selectChoices[this.getQuestionResponse(question.questionId).v].value)
    ).filter(a => !!a)

  saveQuestionResponseComment = (questionId, comment) => {
    const currentValue = this.getQuestionResponse(questionId)
    this.navigateWithState({ [questionId]: { ...currentValue, c: comment } })
  }

  saveMultipleQuestionResponseComment = (questionIdArray, answerIdArray) => {
    const updateState = questionIdArray.reduce((acc, curr, index) => {
      var ans = answerIdArray[index]
      var answered = this.getQuestionResponse(curr).c === ans
      acc[curr] = { ...this.urlState[curr], c: answered ? undefined : ans }
      return acc
    }, {})
    this.navigateWithState(updateState)
  }

  saveMultipleQuestionRaw = (questionIdArray, answerIdArray, isInitial) => {
    const updateState = questionIdArray.reduce((acc, curr, index) => {
      var ans = answerIdArray[index]
      var answerKey
      if (ans.v !== undefined) {
        answerKey = 'v'
      } else {
        answerKey = 'c'
      }
      if (isInitial) {
        acc[curr] = { ...this.urlState[curr], ...ans }
      } else {
        var answered = this.getQuestionResponse(curr)[answerKey] === ans[answerKey]
        acc[curr] = { ...this.urlState[curr], ...(answered ? { [answerKey]: undefined } : ans) }
      }
      return acc
    }, {})
    this.navigateWithState(updateState)
  }

  getQuestionFromOffer = questionId => {
    if (this.offer) {
      const conditions = this.offer.prospect.conditions
      const history = this.offer.prospect.history
      //HACK RV questions should be rewritten to make this simpler
      const rv = this.offer.prospect.replacementVehicle.map(question => {
        if (question.questionId === 'qrv/MakeAndModel') return { ...question, questionId: 'qrv/MakeModel1' }
        return question
      })
      return conditions.find(condition => questionId.startsWith(condition.questionId)) || history.find(history => history.questionId === questionId) || rv.find(question => questionId.startsWith(question.questionId))
    }
    return {}
  }

  getQuestionResponseComment = questionId => {
    let urlResponse = this.urlState[questionId] && this.urlState[questionId].c
    let offerResponse = undefined
    if (!urlResponse) {
      if (this.offer) {
        const question = this.getQuestionFromOffer(questionId)
        const choice = QuestionUtils.mapOfferToQuestionComment(questionId, question)
        if (choice || choice === 0) offerResponse = choice
      }
    }
    return urlResponse || offerResponse || ''
  }

  saveQuestionResponseArray = (arrayId, array) => {
    if (!array.length && this.urlState[arrayId]) {
      this.navigateWithState({ [arrayId]: { ...this.urlState[arrayId], v: array } })
      return
    } else this.navigateWithState({ [arrayId]: { ...this.urlState[arrayId], v: array } })
  }

  getQuestionResponseArray = arrayId => {
    let urlResponse = this.urlState[arrayId] && this.urlState[arrayId].v
    let offerResponse = undefined
    if (urlResponse === undefined && this.offer && arrayId === 'qmeter') {
      offerResponse = this.offer.prospect.paintMeter
    }
    return urlResponse || offerResponse
  }

  saveToUrlState = (name, value) => {
    if (!value && this.urlState[name]) {
      delete this.urlState[name]
      this.navigateWithState()
    } else this.navigateWithState({ [name]: value })
  }

  getFromUrlState = (name, defaultValue) => {
    return this.urlState[name] || defaultValue
  }

  getFromGlobalState = (name, defaultValue) => {
    return this.globalState[name] || defaultValue
  }

  updateVehicleProp = (propName, propValue) => {
    if (propName === 'style') {
      if (propValue) {
        this.changeTrim(propValue)
      }
    } else if (propValue) {
      this.navigateWithState({ [propName.charAt(0)]: propValue })
    }
  }
  changeTrim = (propValue, removes = ['color', 'transmission', 'engine', 'drivetrain', 'options']) => {
    const propName = 'style'
    const newTrim = (this.trims && this.trims.find(tri => +tri.trimId === +propValue)) || {}
    const isBodyStyleDifferent = !this.trim || newTrim.bodyStyle !== this.trim.bodyStyle
    const removeQc = key => key.startsWith('qc/') && isBodyStyleDifferent
    const keepFilter = key => !(removes.some(remove => key === remove.charAt(0)) || removeQc(key))
    this.urlState = Object.keys(this.urlState).reduce((acc, cur) => ({ ...acc, ...(keepFilter(cur) ? { [cur]: this.urlState[cur] } : {}) }), {})
    StorageUtils.clearProspect()
    this.setIsProspectSet(false)

    this.navigateWithState({ [propName.charAt(0)]: propValue })
  }
  getVehicleProp = propName => {
    return this.urlState[propName.charAt(0)]
  }
  updateVehiclePropNumber = (propName, propValue) => {
    if (!isNaN(+propValue)) {
      this.navigateWithState({ [propName.charAt(0)]: +propValue })
    }
  }
  changeVehicleOptionIsSelected = ({ displayName, optionId, isSelected }, userIsSelected) => {
    //Store a minified array of options that have been user interacted to keep url state smaller.
    const urlState = this.urlState
    const urlStateO = urlState.o || []
    const name = optionId.toString()
    urlStateO.push(name + (!isSelected ? 'T' : 'F'))

    // this.resetOptions && this.resetOptions()
    this.navigateWithState({ o: urlStateO })
  }

  mergeOptionArray = (optionArray, newOptionArray) => {
    //Merges changes in to the current array. Needed because update does not have the proper values for relationships field
    const options =
      optionArray &&
      optionArray.map(option => {
        const newOptionSelected = (newOptionArray.find(opt => +opt.optionId === +option.optionId) || option).isSelected
        const newOptionSystemChanged = this.systemChanges && this.systemChanges.find(opt => +opt.optionId === +option.optionId)
        return { ...option, isSelected: newOptionSelected, isSystemChange: !!newOptionSystemChanged }
      })

    this.urlState.o &&
      this.urlState.o.forEach(option => {
        const optionId = option.replace(/[^\d]/, '')
        const isSelected = option.replace(/\d+/, '') === 'T'
        const toChange = options && options.find(opt => +opt.optionId === +optionId)
        if (toChange) toChange.isSelected = isSelected
      })

    this.options = options
  }

  setGenericOptions = (genericOptions, isEditOffer) => {
    if (!isEditOffer) {
      if (genericOptions) {
        if (this.genericOptions !== genericOptions) {
          this.genericOptions = genericOptions
          this.urlState.go = genericOptions
        }
      }
      if (this.urlState.go === undefined) {
        this.genericOptions = (this.offer && this.offer.prospect.genericOptions) || (this.vinResults && this.vinResults.genericOptions)
        this.urlState.go = this.genericOptions
      } else {
        this.genericOptions = this.urlState.go
      }
    } else {
      this.genericOptions = genericOptions
      this.urlState.go = genericOptions
    }
  }
  applySystemChange = (changes, latest) => {
    //splits array into latest and actual changes filters out options that are not present in the options array
    if (this.options) {
      changes = changes.map(change => ({ ...this.options.find(option => +option.optionId === +change.optionId), isSelected: change.isSelected })).filter(x => !!x.optionId)
      this.lastChange = changes.filter(option => +option.optionId === +latest.optionId)
      this.systemChanges = changes.filter(option => +option.optionId !== +latest.optionId)
      this.urlState.o = [...(this.urlState.o || []), ...(this.systemChanges || []).map(change => `${change.optionId}${change.isSelected ? 'T' : 'F'}`).filter(x => !!x)]
    }
  }
  determineVinOptionChanges = () => {
    if (this.offer && this.offer.prospect && this.vinResults) {
      const oldVehicleInfo = this.offer.prospect.vehicle
      const { options, engines, drivetrains, transmissions } = this.vinResults
      const changedOptions = []

      if (this.offer.prospect.options)
        options.forEach(option => {
          const oldOption = this.offer.prospect.options.find(old => old.optionId === option.optionId)
          if (oldOption && oldOption.isSelected !== option.isSelected) changedOptions.push(option)
        })

      // Basic options
      this.applySystemChange(changedOptions, { optionId: 0 })

      const lastChange = this.lastChange ? this.lastChange.slice(0) : []
      const systemChanges = this.systemChanges ? this.systemChanges.slice(0) : []
      let tedChanges = false

      // TED options
      if (engines && engines.length === 1 && engines[0].engineId !== oldVehicleInfo.engineId) {
        lastChange.push(engines[0])
        systemChanges.push({ optionId: oldVehicleInfo.engineId, displayName: oldVehicleInfo.vehicleDescription.engine, isSelected: false })
        tedChanges = true
      }

      if (drivetrains && drivetrains.length === 1 && drivetrains[0].drivetrainId !== oldVehicleInfo.drivetrainId) {
        lastChange.push(drivetrains[0])
        systemChanges.push({ optionId: oldVehicleInfo.drivetrainId, displayName: oldVehicleInfo.vehicleDescription.drivetrain, isSelected: false })
        tedChanges = true
      }

      if (transmissions && transmissions.length === 1 && transmissions[0].transmissionId !== oldVehicleInfo.transmissionId) {
        lastChange.push(transmissions[0])
        systemChanges.push({ optionId: oldVehicleInfo.transmissionId, displayName: oldVehicleInfo.vehicleDescription.transmission, isSelected: false })
        tedChanges = true
      }

      this.lastChange = lastChange
      this.systemChanges = systemChanges
      this.tedChanges = tedChanges
    }
  }
  setHistoryUrlState = () => {
    BrowserUtils.setHistoryUrlState(this.urlState)
  }
  validateUserInfo = (info, value) => {
    const alphabetRegex = /[^a-zA-Z\s'-:]/
    switch (info) {
      case 'firstName':
        if (value.match(alphabetRegex) || value.length === 0) {
          this.updateGlobalState({ firstNameError: true, firstName: value })
        } else {
          this.updateGlobalState({ firstNameError: false, firstName: value })
        }
        break
      case 'lastName':
        if (value.match(alphabetRegex) || value.length === 0) {
          this.updateGlobalState({ lastNameError: true, lastName: value })
        } else {
          this.updateGlobalState({ lastNameError: false, lastName: value })
        }
        break
      case 'email':
        const emailRegex = /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
        if (value.length === 0 || !value.match(emailRegex)) {
          this.updateGlobalState({ emailError: true, email: value })
        } else {
          this.updateGlobalState({ emailError: false, email: value })
        }
        break
      case 'phone':
        const phoneRegex = /^$|[01]?[- .]?(?:\(([2-9]\d{2})\)|([2-9]\d{2}))[- .]?(\d{3})[- .]?(\d{4})/
        if (value.length !== 10 || !value.match(phoneRegex)) {
          this.updateGlobalState({ phoneError: true, phone: value })
        } else {
          this.updateGlobalState({ phoneError: false, phone: value })
        }
        break
      default:
        break
    }
  }
}

export default LandingContext
